module.exports = __webpack_public_path__ + "img/lishigushi@3x.8cdbd4cc.png";